module.exports = __webpack_public_path__ + "img/CLS-P-130.55294f49.svg";